import http from "./http.js";

const buildConfig = (options) => {
  if (!options) return { showLoading: true };
  if (typeof options.showLoading === "boolean") return { showLoading: options.showLoading };
  return { showLoading: false };
};

//发送短信验证
export function sendSmsCode(data) {
  return http.post("/authorize/captcha/sendShortMessageCaptcha", data);
}
//登录
export function login(data, options) {
  return http.post("/authorize/login", data, buildConfig(options));
}
//获取协议
export function getProtocol(params) {
  return http.get(`/sysConfig/getByType/${params.type}`);
}
//渠道绑定
export function bindChannel(channelId, data, options) {
  return http.post(`account/channel/bind/${channelId}`, data, buildConfig(options));
}
//退出登录
export function logout(options) {
  return http.post("/authorize/logout", undefined, buildConfig(options));
}
//提交反馈
export function submitFeedback(data, options) {
  return http.post("/feedback/submit", data, buildConfig(options));
}
//注销
export function unregister(data, options) {
  return http.post("/authorize/logout/logoff", data, buildConfig(options));
}
//文件上传
export function uploadImg(data) {
  return http.post("/upload/file", data);
}
//身份证OCR
export function verificationIdCardOCR(data) {
  return http.post("/verification/aiqian/idCardOCR", data);
}
//活体检测
export function verificationLivePerson(data) {
  return http.post("/verification/livePersonApp", data);
}
//添加联系人
export function addContact(data, options) {
  return http.post("/verification/contact/addVerificationContact", data, buildConfig(options));
}
//修改个人信息
export function updateContactInfo(data, options) {
  return http.post("/verification/contact/updateVerificationInfo", data, buildConfig(options));
}
//创建借贷订单
export function createLoanOrder(data, options) {
  return http.post("/borrow/order/addBorrowOrder", data, buildConfig(options));
}
//获取个人信息
export function getPersonalInfo(data) {
  return http.post("/verification/contact/getVerificationInfo", data);
}
//待借计划
export function getPendingPlan(data) {
  return http.post("/borrow/order/pendingBorrowPlan", data);
}
//在途订单列表
export function getOnroadBorrowOrder(data) {
  return http.post("/borrow/order/getOnroadBorrowOrder", data);
}
//在途订单详情
export function getOnroadBorrowOrderDetail(borrowOrderId) {
  return http.get(`/borrow/order/getOnroadBorrowOrderDetail/${borrowOrderId}`);
}
//银行卡OCR
export function verificationBankCardOCR(data, options) {
  return http.post("/verification/aiqian/bankCardOCR", data, buildConfig(options));
}
//添加身份证
export function addIdCard(data) {
  return http.post("/verification/aiqian/addIdCard", data);
}
//获取首页数据
export function getHomeData(data) {
  return http.post("/borrow/product/getHomeData", data);
}
//用户银行卡列表
export function getBankCardList(params) {
  return http.get("/bank/card/list", { params });
}
//设置默认银行卡
export function setDefaultBankCard(data) {
  return http.post("/bank/card/setDefault", data);
}
//广告列表
export function getAdList(params) {
  return http.get("/agency/adsList", { params });
}
//绑定银行卡
export function bindBankCard(data, options) {
  return http.post("/bank/card/add", data, buildConfig(options));
}
//签署协议
export function sign(data) {
  return http.post("/account/agreement/submitSign", data);
}
//用户协议列表
export function getAgreementList(params) {
  return http.get("/account/agreement/signList", { params });
}
//通知列表
export function getNotifyList(params) {
  return http.get("/notice/list", { params });
}
//贷前检测
export function preCheck(params) {
  return http.get("/borrow/order/orderBeforeCheck", { params });
}
//账单还款
export function repayment(data, options) {
  return http.post("/repay/repaymentOrderIssue", data, buildConfig(options));
}
//查询用户属性
export function getUserInfo() {
  return http.post("/account/getAccountInfo", undefined);
}
//浏览量结算
export function setViewCount(data, options) {
  return http.post("/account/channel/pageViews", data, buildConfig(options));
}
//更新借贷订单
export function updateBorrowOrder(data, options) {
  return http.post("/borrow/order/updateBorrowOrder", data, buildConfig(options));
}
//获取个人实名认证url
export function verificationIdCardOCRWeb(data, options) {
  return http.post("/verification/aiqian/identifyUrl", data, buildConfig(options));
}
//查询实名认证的结果
export function verificationIdCardOCRWebCallback(data) {
  return http.post("/verification/aiqian/getAccountAuthState", data);
}
//获取当前存在订单数量
export function getUnsettledOrderNum(params) {
  return http.get("/borrow/order/unsettledOrderNum", { params });
}
//最新版本
export function getLatestVersion(data) {
  return http.post("/versionControl/getLastUrl", data);
}
//根据key获取配置
export function getSysConfigByKey(key) {
  return http.get(`/sysConfig/getByKey/${key}`);
}
//登录页面获取协议
export function getLoginProtocol(data) {
  return http.post(`/sysConfig/getByType/v2/${data.type}`, data);
}
//实名认证协议
export function getIdCardProtocol(data) {
  return http.post(`/sysConfig/getByType/v3/${data.type}`, data);
}
//借款协议
export function getBorrowProtocol(data) {
  return http.post(`/sysConfig/getByType/v5/${data.type}`, data);
}
//银行卡列表
export function getBankList(params) {
  return http.get("/bank/data/list", { params });
}
//添加通讯录
export function addContacts(data) {
  return http.post("/account/addContactBook", data);
}
